<template>
    <div class="full-bg min-vh-100 vw-100 top-0 left-0 right-0 position-absolute d-flex justify-content-center align-items-center">
        <div class="container" style="z-index: 2;">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FullBackgroundPage',
};
</script>

<style scoped>
    .full-bg {
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url('../../assets/images/background2.jpg');
    }
</style>
